import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import findLastIndex from 'lodash/findLastIndex';
import cloneDeep from 'lodash/cloneDeep';
import trimEnd from 'lodash/trimEnd';
import trimStart from 'lodash/trimStart';
import DOMPurify from 'dompurify';

const trimInsentJsonEnds = json => {
  const contents = json.content;
  if (!contents || contents.length <= 0) return json;
  let startIndex = -1,
    endIndex = contents.length;
  contents.forEach((para, index) => {
    if (
      para.content &&
      para.content.length > 0 &&
      !isEmpty(
        find(para.content, o => {
          if (o.type === 'text' && !isEmpty(o.text?.trim())) {
            return true;
          } else if (o.type !== 'text' && o.type !== 'hardBreak') {
            return true;
          } else {
            return false;
          }
        })
      )
    ) {
      endIndex = index;
      if (startIndex === -1) startIndex = index;
    }
  });

  if (startIndex === -1) {
    return { type: json.type, content: [] };
  }

  let firstSlice, lastSlice;
  firstSlice = findIndex(json.content[startIndex].content, item => item.type !== 'hardBreak');
  lastSlice = findLastIndex(json.content[endIndex].content, item => item.type !== 'hardBreak');
  if (startIndex === endIndex) {
    json.content[startIndex].content = json.content[startIndex].content.slice(
      firstSlice,
      lastSlice + 1
    );
  } else {
    json.content[startIndex].content = json.content[startIndex].content.slice(
      firstSlice,
      json.content[startIndex].content.length
    );
    json.content[endIndex].content = json.content[endIndex].content.slice(0, lastSlice + 1);
  }

  json.content = contents.slice(startIndex, endIndex + 1); // slice only contents

  let endSlice = json.content.length;
  json.content.forEach((content, index) => {
    let listContent = content.content;
    if (content.type === 'bulletList' || content.type === 'orderedList') {
      let listEndSlice = 0;
      listContent.forEach((listItem, index) => {
        const doc = cloneDeep(listItem);
        const listItemTrimmed = trimInsentJsonEnds(doc);
        if (!isEmpty(listItemTrimmed.content)) {
          listContent[index] = listItemTrimmed; // trimming content inside lists
          listEndSlice = index + 1;
        }
      });
      content.content = listContent.slice(0, listEndSlice); // trim empty listItem
      if (isEmpty(content.content)) endSlice = index;
    }
    const sanitizeText = listContent.map(content => {
      if (content.type === 'text' && content.text) {
        const doc = cloneDeep(content);
        doc.text = DOMPurify.sanitize(doc.text);
        return doc;
      } else {
        return content;
      }
    });
    content.content = sanitizeText;
  });

  json.content = json.content.slice(0, endSlice); // remove empty list altogether

  const firstParaIndex = findIndex(json.content, item => item.type === 'paragraph');
  const lastParaIndex = findLastIndex(json.content, item => item.type === 'paragraph');
  if (firstParaIndex !== -1) {
    const textStart =
      !isEmpty(json.content[firstParaIndex].content) &&
      json.content[firstParaIndex].content[0].type === 'text' &&
      json.content[firstParaIndex].content[0];
    const textEnd =
      !isEmpty(json.content[lastParaIndex].content) &&
      json.content[lastParaIndex].content.slice(-1)[0].type === 'text' &&
      json.content[lastParaIndex].content.slice(-1)[0];
    if (textStart && !isEmpty(textStart.text.trim())) textStart.text = trimStart(textStart.text); // trim starting whitespace
    if (textEnd && !isEmpty(textEnd.text.trim())) textEnd.text = trimEnd(textEnd.text); // trim trailing whitespace
  }

  return json;
};

export default trimInsentJsonEnds;
